/* eslint-disable no-invalid-this */
/* eslint-disable no-unused-expressions */

export default function() {
    this.fetchData();
}
